import React from 'react';
import { Shield, Info, Lock } from 'lucide-react';
import styles from '../CSS/PermissionManagement.module.css';

const PermissionManagement = ({ permissions, showFeedback }) => {
  const getPermissionIcon = (permissionId) => {
    const icons = {
      'gestion': '⚙️',
      'correos': '📧',
      'clases': '📚',
      'reservas': '📅',
      'incidencias': '🎫',
      'admin': '👑'
    };
    return icons[permissionId] || '🔐';
  };

  const getPermissionColor = (permissionId) => {
    const colors = {
      'gestion': '#9f7aea',
      'correos': '#ed8936',
      'clases': '#38a169',
      'reservas': '#3182ce',
      'incidencias': '#e53e3e',
      'admin': '#d69e2e'
    };
    return colors[permissionId] || '#6b7280';
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        
        <div className={styles.infoBox}>
          <Info size={16} className={styles.infoIcon} />
          <p className={styles.infoText}>
            Estos son los permisos disponibles en el sistema. Se utilizan para crear roles 
            personalizados que determinan a qué secciones de la aplicación pueden acceder los usuarios.
          </p>
        </div>
      </div>

      <div className={styles.permissionsGrid}>
        {permissions.map(permission => (
          <div 
            key={permission.id} 
            className={styles.permissionCard}
            style={{ 
              borderLeftColor: getPermissionColor(permission.id)
            }}
          >
            <div className={styles.permissionHeader}>
              <div className={styles.permissionIcon}>
                {getPermissionIcon(permission.id)}
              </div>
              <div className={styles.permissionInfo}>
                <h3 className={styles.permissionName}>{permission.name}</h3>
                <span 
                  className={styles.permissionId}
                  style={{ backgroundColor: `${getPermissionColor(permission.id)}20` }}
                >
                  {permission.id}
                </span>
              </div>
            </div>
            <p className={styles.permissionDescription}>
              {permission.description}
            </p>
            <div className={styles.permissionFooter}>
              <div className={styles.permissionDetails}>
                <Lock size={12} />
                <span className={styles.permissionScope}>Permiso del sistema</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      

      
    </div>
  );
};

export default PermissionManagement;